import { StatsSection } from '@/components/dashboard/StatsSection'

// Renamed back from "DAO" to "Stats" (founder call): with Buyback split out to its own page, this
// page is a mostly read-only protocol overview (Overview / Markets / Protocol Health) plus the
// permissionless Liquidations action - "Stats" describes that honestly, where "DAO" implied a
// governance/voting surface that does not exist here. Matches the component name (StatsSection)
// and the original /stats route.
export function StatsPage() {
  return (
    <div style={{ maxWidth: 1280, margin: '0 auto', padding: '24px' }}>
      <StatsSection />
    </div>
  )
}
